import StatItem from "./StatItem";
function Stats({ stats }) {
  return (
    <div className="stats-bar">
      <div className="stats-inner">
        {stats.map((stat) => (
          <StatItem
            key={stat.label}
            icon={stat.icon}
            value={stat.value}
            suffix={stat.suffix}
            label={stat.label}
            isCounter={stat.isCounter}
          />
        ))}
      </div>
    </div>
  );
}

export default Stats;
